import { CURRENCIES, Currencies, roundOf } from '@/utils'
import { PriceProps } from './Price.types'

const CURRENCY_SYMBOLS: Record<Currencies, string> = {
  [CURRENCIES.USD]: '$',
  [CURRENCIES.CAD]: '$',
  [CURRENCIES.EUR]: '€',
  [CURRENCIES.GBP]: '£',
  [CURRENCIES.MXN]: 'MX$',
  [CURRENCIES.AUD]: 'A$',
  [CURRENCIES.JPY]: '¥',
  [CURRENCIES.BRL]: 'R$',
  [CURRENCIES.INR]: '₹',
  [CURRENCIES.KRW]: '₩',
  [CURRENCIES.AED]: 'AED',
  [CURRENCIES.SGD]: 'S$',
}

export function getFormattedPrice({ value, sign, precision = 0, currency }: PriceProps) {
  const currencySymbol = getCurrencySymbol(currency)
  const amountSign = getAmountSign({ value, sign })

  const formattedValue = value < 0 ? roundOf(Math.abs(value), precision) : roundOf(value, precision)
  const thousandSeparatedPrice = formattedValue.toLocaleString(undefined, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })

  return `${amountSign}${currencySymbol}${thousandSeparatedPrice}`
}

function getCurrencySymbol(currency?: Currencies) {
  if (!currency) return CURRENCY_SYMBOLS.USD
  return CURRENCY_SYMBOLS[currency] ?? CURRENCY_SYMBOLS.USD
}

function getAmountSign({ value, sign }: Pick<PriceProps, 'value' | 'sign'>) {
  if (value < 0) return '-'
  if (value >= 0 && sign) return '+'
  return ''
}
